import { $, $$ } from '@utils';
import datalayerPushGeneric from '@utils/DataLayerPushGeneric';

function init() {
  if (!$('[data-au-content-block]')) return;

  addEventListeners();
}

function getPageName() {
  if (Array.isArray(window.dataLayer)) {
    const pageItem = window.dataLayer.find((item) => item && typeof item.pageName === 'string');
    return pageItem ? pageItem.pageName : '';
  }
  return '';
}

function getHeadingLevel(heading) {
  if (!heading) return 7;
  const match = heading.tagName.match(/^H([1-6])$/i);
  return match ? parseInt(match[1], 10) : 7;
}

function getPreviousHeadingTitle(content, elem) {
  const currentHeading = elem.closest('h1, h2, h3, h4, h5, h6');
  const targetElem = currentHeading || elem;
  const currentLevel = currentHeading ? getHeadingLevel(currentHeading) : 7;

  const headings = content.querySelectorAll('h1, h2, h3, h4, h5, h6');
  let previousHeading = null;

  for (const heading of headings) {
    if (heading.compareDocumentPosition(targetElem) & Node.DOCUMENT_POSITION_FOLLOWING) {
      if (getHeadingLevel(heading) < currentLevel) {
        previousHeading = heading;
      }
    } else {
      break;
    }
  }

  if (previousHeading) {
    return previousHeading.innerText.trim();
  }

  return getPageName();
}

function addEventListeners() {
  $$('[data-au-content-block]').forEach((content) => {
    content.querySelectorAll('a, button').forEach((elem) => {
      const contentType = elem.nodeName === 'A' ? 'clickEnlace' : 'clickDescarga';
      const isInsideTabContent = elem.closest('[data-au-tab-content]');
      let titleText = '';
      let clickText = '';
      const clickUrl = elem.nodeName === 'A' ? elem.href || '' : '';

      if (isInsideTabContent) {
        const tabContentId = isInsideTabContent.getAttribute('data-au-tab-content');
        const tab = document.querySelector(`[data-au-tab=${tabContentId}]`);
        tab.childNodes.forEach((value) => {
          if (value.nodeType === Node.TEXT_NODE) titleText = value.nodeValue;
        });
      } else {
        titleText = getPreviousHeadingTitle(content, elem);
      }
      titleText = titleText.length > 100 ? `${titleText.substring(0, 100)}...` : titleText;

      elem.childNodes.forEach((value) => {
        if (value.nodeType === Node.TEXT_NODE)
          clickText = value.nodeValue.length > 100 ? `${value.nodeValue.substring(0, 100)}...` : value.nodeValue;
      });

      elem.addEventListener('click', (e) =>
        datalayerPushGeneric(e, 'navigation', contentType, titleText, clickText, clickUrl),
      );
    });
  });
}

export default { init };
